import { HTMLComponentBuilder } from './html';
import { ArticleEntityWordComponentBuilder } from './entity-word';
import { ArticleHashtagComponentBuilder } from './hashtag';
import { ArticleMentionedUserComponentBuilder } from './mentioned-user';
import { ArticlePoiComponentBuilder } from './poi';
import { ArticleAnchorComponentBuilder } from './anchor';
export const BuiltinComponentBuilderList = [
    ArticleHashtagComponentBuilder,
    ArticleEntityWordComponentBuilder,
    ArticleMentionedUserComponentBuilder,
    ArticlePoiComponentBuilder,
    ArticleAnchorComponentBuilder,
    HTMLComponentBuilder,
];
